<template>
  <div class="toggle">
    <input
      :id="props.id ?? id"
      ref="inputRef"
      v-model="model"
      type="checkbox"
      :disabled="props.disabled"
    />
    <label
      :for="props.id ?? id"
      role="button"
      tabindex="0"
      @keydown.space="inputRef.click()"
    >
      <slot />
    </label>
  </div>
</template>

<script lang="ts" setup>
import { computed, ComputedRef, inject, ref } from "vue";
import { ValidationUtils } from "@/types";

const props = defineProps<{
  modelValue: boolean;
  disabled?: boolean;
  id: string;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
}>();

const inputRef = ref();

const validationUtils =
  inject<ComputedRef<ValidationUtils>>("field-validation");
const id = inject<string>("field-id");

const model = computed({
  get: () => props.modelValue,
  set: (value: boolean) => {
    emit("update:modelValue", value);
    validationUtils?.value.onChange(value);
  },
});

defineExpose({
  inputRef,
});
</script>
